'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _ApiObjectSuggestField = require('./../field/ApiObjectSuggestField');

var _ApiObjectSuggestField2 = _interopRequireDefault(_ApiObjectSuggestField);

var _ObjektApi = require('./../api/gen/objekty/ObjektApi');

var _ObjektApi2 = _interopRequireDefault(_ObjektApi);

var _Utils = require('./../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field pro fulltextové hledání objektů.
 */
var ObjektField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(ObjektField, _AbstractReactCompone);

    function ObjektField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ObjektField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ObjektField.__proto__ || (0, _getPrototypeOf2.default)(ObjektField)).call.apply(_ref, [this].concat(args))), _this), _this.handleFilterSuggestions = function (value) {
            var customFetch = _this.props.customFetch;

            if (value && value !== "") {
                if (customFetch && typeof customFetch === "function") {
                    return customFetch(value);
                }
                return _ObjektApi2.default.findObjektFulltext(value);
            }
            return _promise2.default.resolve([]);
        }, _this.renderObjekt = function (i, active, getItemValue) {
            console.log(i);
            return _react2.default.createElement(
                'div',
                { className: active ? "active" : "" },
                i.objekt.popis && i.objekt.popis
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ObjektField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                renderSuggestion = _props.renderSuggestion,
                other = (0, _objectWithoutProperties3.default)(_props, ['renderSuggestion']);

            return _react2.default.createElement(_ApiObjectSuggestField2.default, (0, _extends3.default)({
                dropdown: true,
                minCharsForFilter: 3,
                placeholder: 'Vyhledat objekt',
                filterSuggestions: this.handleFilterSuggestions,
                getItemValue: function getItemValue(item) {
                    return item ? item.popis : "";
                },
                renderSuggestion: renderSuggestion ? renderSuggestion : this.renderObjekt
            }, other));
        }
    }]);
    return ObjektField;
}(_AbstractReactComponent2.default);

ObjektField.PropTypes = {
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN,
    apiRequestDelay: _react2.default.PropTypes.number,
    customFetch: _react2.default.PropTypes.function,
    renderSuggestion: _react2.default.PropTypes.function
};
ObjektField.defaultProps = {
    apiRequestDelay: 250
};
exports.default = ObjektField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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